import React, { useState } from 'react'
import { Button } from 'antd'
import { Truck } from 'lucide-react'
import { DeliveryCostsDrawer } from './DeliveryCostsDrawer'

export const DeliveryCostsButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        icon={<Truck className="h-4 w-4" />}
        onClick={() => setOpen(true)}
        block
      >
        Delivery Cost Calculation
      </Button>

      <DeliveryCostsDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
